import { Klass, LexicalNode } from "lexical";
import { ListItemNode, ListNode } from "@lexical/list";
import { LinkNode } from '@lexical/link';
import { HeadingNode, QuoteNode } from "@lexical/rich-text";
import { InsertImageNode } from "./InsertImageNode";
import { InsertMentionNode } from './InsertMentionNode';
import { InsertReplyNode } from './InsertReplyNode';
import { InsertVideoNode } from "./InsertVideoNode";

export const nodes: Klass<LexicalNode>[] = [
    HeadingNode,
    QuoteNode,
    ListItemNode,
    ListNode,
    LinkNode,
    InsertImageNode,
    InsertMentionNode,
    InsertReplyNode,
    InsertVideoNode,
];